import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, CardBody,Row,Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter  } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import './FT.css';
import { useParams } from 'react-router-dom';
import * as moment from 'moment'

const modeloDatos = {
    pedidoID: 0,
    empresaID: 0,
    numeroUnico: 0,
    clienteID: 0,
    nombreCliente: "",
    rnc: "",
    tipoComprobante: "",
    ncf: "",
    fecha: new Date,
    comentario: "",
    estatus: 0
}
const modeloDatos1 = {
    pedidoLineaID: 0,
    pedidoID: 0,
    empresaID: 0,
    numeroUnico: 0,
    articuloID: 0,
    descripcionArticulo: "",
    telefono: "",
    almacenID: 0,
    cantidad: 0,
    costo: 0.00,
    precio: 0.00,
    totalLinea: 0.00,
    fecha: new Date
}
const modeloDatosc = {
    clienteID: 0,
    empresaID: 1,
    descripcion: "",
    rnc: "",
    direccion: "",
    telefono: "",
    correo: ""


}

var SubTotal = 0.00;
var totalDescuento = 0.00;
var totalITBIS = 0.00;
var totalPago = 0.00;
var impresion = '';
var Leatendio = '';

const ImpresionCotizacion = () => {
    let { Pedido } = useParams();
   


    const [ListadoLineas, SetListadoLineas] = useState([modeloDatos1]);
    const [Listado, SetListado] = useState([modeloDatos]);
    const [ListadoClientes, SetListadoClientes] = useState([modeloDatosc]);
    const [Empresa, SetEmpresa] = useState([]);
    const [SN, SetSN] = useState();
    const [VerFactura, SetVerFactura] = useState(true);
    const [VerImprimir, SetVerImprimir] = useState(false);


    useEffect(() => {
        obtenerDatos(Pedido)
       
        
    }, [])

    const obtenerDatosSN = async (e) => {
        let response = await fetch(Api + "Administracion/SecuenciaNumerica");
        if (response.ok) {
            let data = await response.json();
            var d = data.filter(x => x.secuenciaID == parseInt(e)).map(x => x.descripcion);
            SetSN(d)
        }
    }

    const obtenerDatos = async (e) => {
        let response = await fetch(Api + "VentasTrans/ListaPedidoCotizacionID/"+ parseInt(e));
        if (response.ok) {
            let data = await response.json();
            SetListado(data[0])
           
            obtenerDatosLineas(data[0].facturaID,data[0].ncf)
            obtenerDatosClientes(data[0].clienteID)
            obtenerDatosEmpresa(data[0].empresaID)
            obtenerDatosSN(data[0].tipoComprobante)
            obtenerUsuarios(data[0].creadoPor)

            var subt = data[0].subTotal;
            SubTotal = currencyFormatter({
                currency: "USD",
               value: subt
            })
        }
    }

    const obtenerDatosLineas = async (pl,ncf) => {
        let response = await fetch(Api + "VentasTrans/ListaPedidoCotizacionLineasF/" + pl);
        if (response.ok) {
            let data = await response.json()
            var d = data.filter(x => x.ncf === ncf).map(x => x)
            SetListadoLineas(d)

       
        }
    }

    const obtenerDatosClientes = async (c) => {
        let response = await fetch(Api + "VentasMantenimiento/ListaClientesID/"+ c);

        if (response.ok) {
            let data = await response.json()
         SetListadoClientes(data[0])
        }
    }
    const obtenerDatosEmpresa = async (e) => {
        let response = await fetch(Api + "Administracion/ListaEmpresas/" + e);
        if (response.ok) {
            let data = await response.json();
            var d = data.filter(x => x.empresaID == e).map(e => e)
            SetEmpresa(d[0])
        }
    }

    const obtenerUsuarios = async (u) => {
        let response = await fetch(Api + "usuario/Lista/1");

        if (response.ok) {
            let data = await response.json()
            let fd = data.filter(x => x.correo == u).map(x => x)
            if (u != 'admin@gmail.com') {
            //    impresion = fd[0].impresionPuntoVenta;
           //     Leatendio = fd[0].nombre;
            }
            SetVerFactura(false)
        }
    }


   // function currencyFormatter({ currency, value }) {
    const currencyFormatter=({ currency, value }) =>{
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            minimumFractionDigits: 2,
            currency
        })
        return formatter.format(value)
    }

    const Imprimir = () => {
     
        window.print();
        SetVerImprimir(true)
    }
   
    //const dollar = currencyFormatter({
    //    currency: "USD",
    //   Listado.subTotal
    //})

    return (
        <>
            <div hidden={VerFactura}>
          {/*   <div className="verturno " hidden={VerFactura} style={{ fontSize: "10px",color:"black"} }>
               <div class="page">
                <div style={{ textAlign: "center" } }><h4>{Empresa.descripcion}</h4>
                <div>{Empresa.direccion}</div>
                <div hidden={Listado.tipoComprobante == 1} > RNC :{Empresa.rnc}</div>
                    Tel:{Empresa.telefono} Correo: {Empresa.email}</div>
                <br></br>
                <div style={{ textAlign: "left" }}>
                    <div>{SN}</div>
                    <div hidden={Listado.tipoComprobante == 1}><b>NCF:</b>{Listado.ncf}</div>
                    <div hidden={Listado.tipoComprobante != 1}><b>Factura No:</b>{Listado.ncf}</div>
                    <div hidden={Listado.tipoComprobante == 1}><b>Valido Hasta:</b>{moment(Listado.fechaValido).format("DD/MM/YYYY")}</div>
                    <div><b>Orden No:</b>{Listado.facturaID}</div>
                    <div><b>Fecha:</b>{moment(Listado.fecha).format("DD/MM/YYYY")}</div>

                    <div hidden={Listado.tipoComprobante == 1}><b>RNC:</b> {Listado.rnc}</div>
                    <div><b>Cliente:</b> {Listado.nombreCliente}</div>
                    <div><b>Telefono:</b> {Listado.telefono}</div>
                    <div><b>Dirección:</b> {ListadoClientes.direccion}</div>
                    <div><b>Email: </b>{ListadoClientes.correo}</div>

                
                   
                </div>

                <div >
                    <table>
                       
                            <tr>
                                <th>Descripción</th>
                                <th>Cantidad</th>
                                <th>Precio unitario</th>
                                <th>Total</th>
                            </tr>
                     
                            {ListadoLineas.map(x => (
                                <tr>
                                    <td>{x.descripcionArticulo}</td>
                                    <td>{x.cantidad}</td>
                                    <td>${x.totalLinea.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                                    <td>${(x.totalLinea * x.cantidad).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                                </tr>

                            ))}
                    </table>
                </div>

                <div class=""  >

                    <div hidden={Listado.tipoComprobante != 1}><b>Sub-Total: </b>{currencyFormatter({ currency: "USD", value: Listado.subTotal })}</div>
                    <div hidden={Listado.tipoComprobante == 1}><b>Sub-Total: </b>{currencyFormatter({ currency: "USD", value: Listado.subTotal })}</div>
                    <div><b>Desc.:</b> {currencyFormatter({ currency: "USD", value: Listado.totalDescuento })}</div>
                    <div hidden={Listado.tipoComprobante == 1} ><b>18% ITBIS:</b> {currencyFormatter({ currency: "USD", value: Listado.totalITBIS })}</div>
                    <div><b>Total:</b> {currencyFormatter({ currency: "USD", value: Listado.totalPago })}</div>


                </div>

               </div>

          

            </div>
           
            <div>*/}
             
                <div class="containerP" hidden={!impresion} onClick={() => Imprimir()} >
              
                        <div style={{ textAlign: "center" }}><h4>{Empresa.descripcion}</h4>
                    <div style={{  fontSize: "12px" }} >  <div>{Empresa.direccion}</div>
                        <div  > RNC :{Empresa.rnc}</div>
                        <b>Tel:</b>{Empresa.telefono}  <b>Correo: </b>{Empresa.email}</div>
                      </div>  <br></br>
                <div style={{ textAlign: "left", fontSize: "12px" }}>
                        <div>{SN}</div>
                        <div hidden={Listado.tipoComprobante == 1}><b>No:</b>{Listado.ncf}</div>
                        <div hidden={Listado.tipoComprobante != 1}><b>Factura No:</b>{Listado.ncf}</div>
                        {/*<div hidden={Listado.tipoComprobante == 1}><b>Valido Hasta:</b>{moment(Listado.fechaValido).format("DD/MM/YYYY")}</div>*/}
                        <div><b>Orden No:</b>{Listado.facturaID}</div>
                        <div><b>Fecha:</b>{moment(Listado.fecha).format("DD/MM/YYYY")}</div>

                        <div hidden={Listado.tipoComprobante == 1}><b>RNC:</b> {Listado.rnc}</div>
                        <div><b>Cliente:</b> {Listado.nombreCliente}</div>
                    <div><b>Telefono:</b> {Listado.telefono} <b>Email: </b>{ListadoClientes.correo}</div>
                        <div><b>Dirección:</b> {ListadoClientes.direccion}</div>
                      



                    </div>
                    <br></br>
               
                <div style={{ textAlign: "left", fontSize: "10px" }} >
                        <table>

                            <tr>
                                <th>Descripción</th>
                                <th>Cantidad</th>
                                <th>Precio</th>
                                <th>Total</th>
                            </tr>

                            {ListadoLineas.map(x => (
                                <tr key={x.facturaLineaID }>
                                    <td>{x.descripcionArticulo}</td>
                                    <td>{x.cantidad}</td>
                                    <td>${x.totalLinea.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                                    <td>${(x.totalLinea * x.cantidad).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                                </tr>

                            ))}
                        </table>
                    </div>
                    <div class="footer">
                        <div class=""  >
{/*hidden={Listado.tipoComprobante != 1}*/}
                        <div ><b>Sub-Total: </b>{currencyFormatter({ currency: "USD", value: Listado.subTotal+ Listado.totalITBIS })}</div>
                            <div hidden={true}><b>Sub-Total: </b>{currencyFormatter({ currency: "USD", value: Listado.subTotal })}</div>
                            <div><b>Desc.:</b> {currencyFormatter({ currency: "USD", value: Listado.totalDescuento })}</div>
                            <div hidden={true} ><b>18% ITBIS:</b> {currencyFormatter({ currency: "USD", value: Listado.totalITBIS })}</div>
                            <div><b>Total:</b> {currencyFormatter({ currency: "USD", value: Listado.totalPago })}</div>


                    </div>
                        <br></br>
                    <p>Le Atendio: {Leatendio}</p>
                    <p>Gracias por visitarnos</p>
                    <br></br>
                    </div>
                </div>
      

                <div class="letra" hidden={impresion} onClick={() => Imprimir()}>

              
                
                <div class="printArea">
                    <div class="page">

                     
                        <html lang="en">
                        
                                    <body>

                                        <div class="container">
                                    <div class="header">
                                      
                                            <table className="tableh" style={{ textAlign: "left"} } >
                                            <tr >
                                                    <td style={{ width: "20%", border: "0px" }} onClick={() => Imprimir()} >
                                                        <img class="card-img-top" src="./imagen/LogoEmpresa/Logo.png" style={{ width: '200px', height: '150px' }} />
                                                </td>  
                                                    <td style={{ border: "0px", textAlign: "left" }}>
                                                    <h2>{Empresa.descripcion}</h2>
                                                   <div>{Empresa.direccion}</div> 
                                                    <div hidden={Listado.tipoComprobante ==1 } > RNC :{Empresa.rnc}</div>
                                                    Tel:{Empresa.telefono} Correo: {Empresa.email}

                                                   
                                                </td>
                                            </tr>
                                        </table>
                                     
                                      
                                            </div>

                                            <div class="bill-info">
                                                <div>
                                                    <h2>Cliente:</h2>
                                            <p hidden={Listado.tipoComprobante == 1}><b>RNC:</b> {Listado.rnc }</p>
                                        <div><b>Nombre:</b> {Listado.nombreCliente }</div>
                                    <div><b>Telefono:</b> {Listado.telefono }</div>
                                <div><b>Dirección:</b> {ListadoClientes.direccion }</div>
                            <div><b>Email: </b>{ListadoClientes.correo}</div>
                                          
                                                </div>
                                                <div>
                                                    <h2>Cotización:</h2>
                                            <div>{SN}</div>
                                            <div hidden={Listado.tipoComprobante == 1}><b>NCF:</b>{Listado.ncf}</div>
                    <div hidden={Listado.tipoComprobante != 1}><b>Cotización No:</b>{Listado.ncf}</div>
                   
                    <div><b>Orden No:</b>{Listado.facturaID}</div>
                                            <div><b>Fecha:</b>{moment(Listado.fecha).format("DD/MM/YYYY")}</div>
                                            <div><b>Condición:</b>{Listado.credito == 0 ? 'Contado' : 'Credito' }</div>
                                        </div>
                                            </div>
                                    <div style={{ height: '6.02in'} }>
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>Descripción</th>
                                                        <th>Cantidad</th>
                                                        <th>Precio unitario</th>
                                                        <th>Total</th>
                                                    </tr>
                                                </thead>
                                        <tbody>
                                            {ListadoLineas.map(x =>(
                                                    <tr>
                                                    <td>{x.descripcionArticulo }</td>
                                                    <td>{x.cantidad }</td>
                                                    <td>${x.precio.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                                                    {/*<td hidden={!Empresa.itbisIncluido}>${(x.precio * x.cantidad ).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>*/}
                                                   
                                                    {/*<td hidden={Empresa.itbisIncluido}>${(x.precio + x.itbis).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>*/}
                                                    <td >${((x.precio ) * x.cantidad ).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                                                    </tr>
                                            
                                           ) )}
                                                </tbody>
                                        </table>
                                    </div>
                                    <br></br>
                                    <br></br>
                                    <div class="bill-info">
                                        <div style={{ width: "70%" }} >
                                        <b> Comentario:</b> {Listado.comentario }
                                        </div>
                                        <div style={{ width: "10%" }}></div>
                                        <div class="" style={{ width: "20%" }} hidden={!Empresa.itbisIncluido } >
                                         
                                            <div hidden={Listado.tipoComprobante != 1}><b>Sub-Total: </b>{currencyFormatter({ currency: "USD", value: (Listado.subTotal + Listado.totalITBIS) })}</div>
                                            <div hidden={Listado.tipoComprobante == 1}><b>Sub-Total: </b>{currencyFormatter({ currency: "USD", value: Listado.subTotal })}</div>
                                            <div><b>Desc.:</b> {currencyFormatter({ currency: "USD", value: Listado.totalDescuento })}</div>
                                            <div hidden={Listado.tipoComprobante == 1} ><b>18% ITBIS:</b> {currencyFormatter({ currency: "USD", value: Listado.totalITBIS })}</div>
                                            <div><b>Total:</b> {currencyFormatter({ currency: "USD", value: Listado.totalPago })}</div>


                                        </div>
                                        <div class="" style={{ width: "20%" }} hidden={Empresa.itbisIncluido} >
                                          
                                            <div hidden={Listado.tipoComprobante != 1}><b>Sub-Total: </b>{currencyFormatter({ currency: "USD", value: (Listado.subTotal + Listado.totalITBIS) })}</div>
                                            <div hidden={Listado.tipoComprobante == 1}><b>Sub-Total: </b>{currencyFormatter({currency: "USD",value: Listado.subTotal})}</div>
                                            <div><b>Desc.:</b> {currencyFormatter({ currency: "USD", value: Listado.totalDescuento })}</div>
                                            <div hidden={Listado.tipoComprobante == 1} ><b>18% ITBIS:</b> {currencyFormatter({ currency: "USD", value: Listado.totalITBIS })}</div>
                                            <div><b>Total:</b> {currencyFormatter({ currency: "USD", value: Listado.totalPago })}</div>


                                        </div>
                                    </div>
                                    <br></br>
                                    <br></br> 
                                    <div class="bill-info">
                                       

                                        <div style={{
                                            //borderTop: '2px solid',
                                            width: '30%',
                                            textAlign: 'center'} }>
                                                <img class="card-img-top" src="./imagen/LogoEmpresa/Firma.png" style={{ width: '200px', height: '90px', borderBottom: '2px solid' }} />
                                         Realizado Por
                                        </div>
                                     
                                        <div style={{
                                           // borderTop: '2px solid',
                                            width: '30%', height: '100px',
                                            textAlign: 'center'
                                        }}>
                                            <div style={{ width: '200px', height: '90px', borderBottom: '2px solid' }}></div>
                                       Recibido Por


                                        </div>
                                    </div>


                                        </div>

                                    </body>
                                </html>

                       

                    </div>

                </div>
            </div>
            </div>
        </>
        )

}
export default ImpresionCotizacion;
